import {
    MEMBER_MEMBERSHIP_LOADING, MEMBER_MEMBERSHIP_SUCCESS,
    MEMBER_MEMBERSHIP_ERROR, RESET_MEMBER_MEMBERSHIP
} from "../actions/actionMemberMemberships";

const initialState = {
    membermerberhips: [],
    loading: false,
    membermerberhipsError: ''
};

function reducerMemberMemberships(state = initialState, action) {

    switch (action.type) {
        case MEMBER_MEMBERSHIP_LOADING: {
            return {
                ...state,
                loading: true
            };
        }

        case MEMBER_MEMBERSHIP_SUCCESS: {

            return {
                ...state,
                membermerberhips: action.payload,
                membermerberhipsError: ''
            };
        }

        case RESET_MEMBER_MEMBERSHIP: {

            return {
                ...state,
                membermerberhips: [],
                membermerberhipsError: ''
            };
        }

        case MEMBER_MEMBERSHIP_ERROR: {

            return {
                ...state,
                loading: false,
                membermerberhipsError: action.error
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerMemberMemberships;